import { toUpper, deburr, get, isNil, omitBy, toString } from 'lodash/fp';

import { makeInitials } from '../utils/playerUtils';

const omitNil = omitBy(isNil);

function decodeTeam(team = {}, position = {}, teamGame) {
  const game = teamGame || get('game', team);
  const countryCode = get('competition.competition_type.country.iso_alpha_2_code', game);
  const hideProgress = !!get('competition.competition_type.sport.game_progress_irrelevant', game);

  return omitNil({
    awayAbbr:
      get('away_team.abbreviation', game) ||
      get('away_team_abbreviation', game) ||
      get('away_team.name', game) ||
      get('away_team_name', game),
    awayId: toString(get('away_team.id', game) || get('away_team_id', game)),
    awayTeam: get('away_team.name', game) || get('away_team_name', game),
    average: parseFloat(get('average_onescore', team)) || 0,
    form: parseFloat(get('three_game_average', team)) || 0,
    gameId: game ? toString(get('id', game)) : undefined,
    homeAbbr:
      get('home_team.abbreviation', game) ||
      get('home_team_abbreviation', game) ||
      get('home_team.name', game) ||
      get('home_team_name', game),
    homeId: toString(get('home_team.id', game) || get('home_team_id', game)),
    homeTeam: get('home_team.name', game) || get('home_team_name', game),
    id: toString(team.id),
    idStr: `TEAM_${team.id}`,
    imageURI: team.image,
    initials: makeInitials(team.name),
    isHome: team.is_home_team || team.id === get('home_team.id', game),
    isLocked: get('is_locked', game),
    isTeam: true,
    labels: [],
    name: team.name,
    nameLookup: toUpper(deburr(team.name)),
    onesportEntityId: get('onesport_id', team),
    preferredName: team.name,
    popularity: team.selected_percentage !== null ? parseInt(team.selected_percentage, 10) : null,
    positions: position.id ? [position] : [],
    positionStr: position.abbr,
    positionAbbr: position.abbr,
    progress: !hideProgress ? get('progress', game) : undefined,
    reverseOrder: countryCode ? countryCode === 'US' : undefined,
    salary: team.salary,
    score: get('fantasy_score', team) || 0,
    statusId: get('status.id', game),
    statusName: get('status.name', game),
    teamAbbr: team.abbreviation,
    teamId: toString(team.id)
  });
}

export default decodeTeam;
